<script setup lang="ts">
const localePath = useLocalePath()
defineProps<{
  /** automatically converted to locale path */
  to: string
}>()
</script>

<template>
  <NuxtLink
    :to="localePath(to)"
    class="bordershadow-gray flex h-8 w-auto items-center gap-x-2 self-start rounded-full bg-gray-50 pl-3 pr-4 text-sm font-medium text-gray-900 transition hover:bg-gray-100"
  >
    <Icon name="lucide:move-left" size="18" />
    <slot />
  </NuxtLink>
</template>
